<div class="news-item-popup-container">
  <div class="news-item-popup-close"><span class="fa-solid fa-xmark" (click)="close()"></span></div>
  <div class="news-item-popup-wrapper" #scrollContainer>
    <div class="news-item-popup-image">
      <img src="{{imageSrc}}" alt="Image illustrating the story" />
    </div>
    <div class="news-item-popup-title">{{title}}</div>
    <div class="news-item-popup-body" [innerHTML]="content|safehtml"></div>
  </div>

</div>
